import { Injectable } from '@angular/core';
import { AgencyForEdit } from '../core/models/AgencyForAdd';
import { REConfig } from '../core/models/RealEstateAgency';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class AgencyService {
  constructor(private apiService: ApiService) {}

  getAgency() {
    return this.apiService.get(`/api/realEstateAgency/`);
  }

  updateAgency(agencyForUpdate: AgencyForEdit) {
    return this.apiService.patch(`/api/realEstateAgency/${agencyForUpdate.id}`, agencyForUpdate);
  }

  updateConfig(agencyId: number, updatedConfig: REConfig) {
    return this.apiService.patch(`/api/realEstateAgency/Config/${agencyId}`, updatedConfig);
  }

  getReportEmails() {
    return this.apiService.get(`/api/realEstateAgency/ReportEmails`);
  }

  updateReportEmails(reportEmails: string[]) {
    return this.apiService.put(`/api/realEstateAgency/ReportEmails`, { reportEmails });
  }

  addReportEmail(email: string) {
    return this.apiService.post(`/api/realEstateAgency/ReportEmails`, { email });
  }

  removeReportEmail(email: string) {
    return this.apiService.delete(`/api/realEstateAgency/ReportEmails/${encodeURIComponent(email)}`);
  }

  sendTestReportEmail(testEmail: string) {
    return this.apiService.post(`/api/realEstateAgency/ReportEmails/SendTest`, { TestEmail: testEmail });
  }
}
